import React from 'react';
import { withRouter, Link } from 'react-router-dom';
import { message } from 'antd';
import { Title } from '$app/shared/components/Header';
import { Container } from '$app/shared/components/Container';

import ProductEditForm from '../ProductEditForm';
import { createProduct, getErrorMessage } from '../../productApi';

function ProductCreatePage(props) {
  const { history } = props;

  return (
    <Container style={{ margin: '20px' }}>
      <Link to="/">Back to the list</Link>
      <Title>Create Product</Title>
      <ProductEditForm
        isNew
        onSave={async (payload) => {
          try {
            message.info('Creating product...');
            await createProduct(payload);
            message.success('Product created');
            history.push(`../edit/${payload.product.sku}`);
          } catch (error) {
            message.error(getErrorMessage(error));
          }
        }}
        operation={{}}
      />
    </Container>
  );
}

export default withRouter(ProductCreatePage);
